import { render, staticRenderFns } from "./painmanagement.vue?vue&type=template&id=0d0ba06b&scoped=true"
import script from "./painmanagement.vue?vue&type=script&lang=js"
export * from "./painmanagement.vue?vue&type=script&lang=js"
import style0 from "./painmanagement.vue?vue&type=style&index=0&id=0d0ba06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ba06b",
  null
  
)

export default component.exports